// controllers
import { UserController } from "controllers";

export const didReceiveProduct = async (customer, product) => {

    if (!customer?.id) { return null; }
    if (!customer.boxes) {
        customer.boxes = await UserController.getUserBoxes(customer.id);
        for (const box of customer.boxes) {
            box.items = await UserController.getUserBoxItems(customer.id, box.id);
        }
    }

    const { boxes } = customer;
    const images = boxes.map((box) => box.items)
        .flat()
        .map((item) => item.imageURL);
    const result = images.includes(product.imageURLs[0]);

    return result;
}
